'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    height: 60px;\n    border: 1px solid #EEEEEE;\n    ', '\n    ', '\n    ', '\n    ', '\n'], ['\n    display: flex;\n    height: 60px;\n    border: 1px solid #EEEEEE;\n    ', '\n    ', '\n    ', '\n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    border-radius: 3px;\n    background: ', ';\n    height: 5px;\n'], ['\n    display: flex;\n    border-radius: 3px;\n    background: ', ';\n    height: 5px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    border-radius: 3px;\n    background: ', ';\n    width: 5px;\n'], ['\n    display: flex;\n    border-radius: 3px;\n    background: ', ';\n    width: 5px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../constants/colors');

var _opacity = require('../../constants/opacity');

var _opacity2 = _interopRequireDefault(_opacity);

var _alignments = require('../../constants/alignments');

var _sizes = require('../../constants/sizes');

var _getColor = require('../../helpers/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _header = require('../../atoms/text/header');

var _header2 = _interopRequireDefault(_header);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TabContainer = (0, _styledComponents2.default)(_container2.default)(_templateObject, function (_ref) {
    var expanded = _ref.expanded,
        mobile = _ref.mobile;
    return expanded && !mobile && 'height: 80px;';
}, function (_ref2) {
    var inactiveBackground = _ref2.inactiveBackground;
    return inactiveBackground && 'background: ' + inactiveBackground + ';';
}, function (_ref3) {
    var active = _ref3.active,
        activeBackground = _ref3.activeBackground;
    return active && 'background: ' + (activeBackground ? activeBackground : (0, _getColor2.default)(_colors.Colors.PrimaryText, _opacity2.default.UltraLight)) + ';';
}, function (_ref4) {
    var hover = _ref4.hover,
        hoverBackground = _ref4.hoverBackground;
    return hover && 'background: ' + (hoverBackground ? hoverBackground : (0, _getColor2.default)(_colors.Colors.Secondary, _opacity2.default.Lighter)) + ';';
});

var HorizontalDivider = (0, _styledComponents2.default)(_container2.default)(_templateObject2, function (_ref5) {
    var active = _ref5.active;
    return active ? (0, _getColor2.default)(_colors.Colors.Primary, _opacity2.default.Dark) : (0, _getColor2.default)(_colors.Colors.PrimaryText, _opacity2.default.Lighter);
});

var VerticalDivider = (0, _styledComponents2.default)(_container2.default)(_templateObject3, function (_ref6) {
    var active = _ref6.active;
    return active ? (0, _getColor2.default)(_colors.Colors.Primary, _opacity2.default.Dark) : (0, _getColor2.default)(_colors.Colors.PrimaryText, _opacity2.default.Lighter);
});

var Tabbed = function (_Component) {
    _inherits(Tabbed, _Component);

    function Tabbed(props) {
        _classCallCheck(this, Tabbed);

        var _this = _possibleConstructorReturn(this, (Tabbed.__proto__ || Object.getPrototypeOf(Tabbed)).call(this, props));

        _this.state = {
            currentTab: 0,
            hoverTab: null
        };
        return _this;
    }

    _createClass(Tabbed, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var xs = this.props.xs || 12;
            var md = this.props.md || 6;
            var lg = this.props.lg || 4;

            var hasDescription = this.props.items && this.props.items.length > 0 && this.props.items.some(function (x) {
                return x.description;
            });

            return _react2.default.createElement(
                _grid2.default,
                null,
                _react2.default.createElement(
                    _row2.default,
                    null,
                    this.props.items && this.props.items.length > 0 && this.props.items.map(function (item, index) {
                        return _react2.default.createElement(
                            _column2.default,
                            { xs: xs, md: md, lg: lg, nogutter: true },
                            _react2.default.createElement(
                                TabContainer,
                                {
                                    inline: _this2.context.screen.isMobile,
                                    mobile: _this2.context.screen.isMobile,
                                    expanded: hasDescription,
                                    active: index === _this2.state.currentTab,
                                    hover: index === _this2.state.hoverTab,
                                    activeBackground: _this2.props.activeBackground,
                                    inactiveBackground: _this2.props.inactiveBackground,
                                    hoverBackground: _this2.props.hoverBackground,
                                    mouseEnterEvent: function mouseEnterEvent() {
                                        return _this2.setState({ hoverTab: index });
                                    },
                                    mouseLeaveEvent: function mouseLeaveEvent() {
                                        return _this2.setState({ hoverTab: null });
                                    },
                                    clickEvent: function clickEvent() {
                                        _this2.setState({ currentTab: index });
                                        _this2.props.clickEvent(index);
                                    } },
                                _this2.context.screen.isMobile && _react2.default.createElement(VerticalDivider, { active: index === _this2.state.currentTab, top: _sizes.Sizes.xxs, bottom: _sizes.Sizes.xxs, left: _sizes.Sizes.xxs, right: _sizes.Sizes.xxs }),
                                _react2.default.createElement(
                                    _container2.default,
                                    { verticalAlignment: _this2.context.screen.isMobile ? _alignments.Alignments.center : _alignments.Alignments.bottom, horizontalAlignment: _this2.context.screen.isMobile ? _alignments.Alignments.left : _alignments.Alignments.center, left: _sizes.Sizes.xs, right: _sizes.Sizes.xs },
                                    _react2.default.createElement(_header2.default, { top: !_this2.context.screen.isMobile && _sizes.Sizes.xs,
                                        left: _this2.context.screen.isMobile && _sizes.Sizes.xxs,
                                        size: _sizes.Sizes.sm,
                                        textAlign: _this2.context.screen.isMobile ? _alignments.Alignments.left : _alignments.Alignments.center,
                                        text: item.code
                                    }),
                                    hasDescription && _react2.default.createElement(_label2.default, { top: _sizes.Sizes.none,
                                        left: _this2.context.screen.isMobile && _sizes.Sizes.xxs,
                                        size: _this2.props.descriptionSize || _sizes.Sizes.sm,
                                        textAlign: _this2.context.screen.isMobile ? _alignments.Alignments.left : _alignments.Alignments.center,
                                        text: item.description })
                                ),
                                !_this2.context.screen.isMobile && _react2.default.createElement(HorizontalDivider, { active: index === _this2.state.currentTab, top: _sizes.Sizes.xxs, bottom: _sizes.Sizes.xs, left: _sizes.Sizes.xs, right: _sizes.Sizes.xs })
                            )
                        );
                    })
                )
            );
        }
    }]);

    return Tabbed;
}(_react.Component);

Tabbed.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = Tabbed;